import { ICompany } from 'app/shared/model/company.model';
import { IMaintenanceModel } from 'app/shared/model/maintenance-model.model';
import { IVehicleModel } from 'app/shared/model/vehicle-model.model';

export interface ITruckImplement {
  id?: number;
  chassisNumber?: string | null;
  licensePlate?: string | null;
  imageContentType?: string | null;
  image?: string | null;
  objectKey?: string | null;
  description?: string | null;
  company?: ICompany | null;
  imageUrl?: string | null;
  fabricationYear?: string | null;
  modelYear?: string | null;
  purchaseDate?: string | null;
  activated?: boolean | null;
  favorite?: boolean | null;
  vehicleModel?: IVehicleModel | null;
  maintenanceModel?: IMaintenanceModel | null;
}

export interface TruckImplementListDTO {
  id: number;
  licensePlate: string;
  description?: string | null;
  truckGroupId?: number | null;
  truckGroupName?: string | null;
}

export const defaultValue: Readonly<ITruckImplement> = {
  activated: true,
};
